import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react';

import type { Language } from './Language';
import { LanguageContext, type LanguageState } from './LanguageContext';
import { readStoredLanguage, writeStoredLanguage } from './storedLanguage';
import { translate } from './translate';

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguageState] = useState<Language>(readStoredLanguage);

  const setLanguage = useCallback((next: Language): void => {
    writeStoredLanguage(next);
    setLanguageState(next);
  }, []);

  // The tab title and the document language are words on screen too (Conventions/06 §3).
  useEffect(() => {
    document.documentElement.lang = language;
    document.title = translate(language, 'app.title');
  }, [language]);

  const value = useMemo<LanguageState>(
    () => ({ language, setLanguage, t: (key, parameters) => translate(language, key, parameters) }),
    [language, setLanguage],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
